import { AppState } from '../state/App.state';
import * as fromQuoteReducer from '../reducers/quote.reducer';
import * as fromMarineQuoteReducer from '../reducers/marinequote.reducer';
import * as fromStatusActionsReducer from '../reducers/status-actions.reducer';
import * as fromTokenActionsReducer from '../reducers/authToken.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { ActionReducer } from '@ngrx/store';
import * as fromProposalPreviewReducer from '../reducers/proposalpreview.reducer';
import * as fromLoggedInUserDetailsReducer from '../reducers/loggedInUserDetails.reducer';
import * as fromSMLoggedInUserDetailsReducer from '../reducers/SMloggedInUserDetails.reducer';
import * as fromSMLoggedInUserAllCodesReducer from '../reducers/SMloggedInUserAllCodes.reducer';
import * as fromSMLoggedInUserOfficeCodesReducer from '../reducers/SMloggedInUserOfficeCodes.reducer';
import * as fromSMLoggedInUserDirectBusinessCodesReducer from '../reducers/SMloggedInUserBussinessCodes.reducer';
import * as fromSMLoggedInUserIMDCodesReducer from '../reducers/SMloggedInUserIMDCodes.reducer';

export const reducers: ActionReducerMap<AppState, any> = {
    marineQuoteData: fromMarineQuoteReducer.marinequoteDataReducer,
    quoteData: fromQuoteReducer.quoteDataReducer,
    statusActionsData: fromStatusActionsReducer.statusActionsDataReducer,
    proposalpreviewData: fromProposalPreviewReducer.proposalpreviewDataReducer,
    loggedInUserData: fromLoggedInUserDetailsReducer.loggedInUserDataReducer,
    SMloggedinUserData: fromSMLoggedInUserDetailsReducer.SMloggedInUserDataReducer,
    SMloggedInUserAllCodes: fromSMLoggedInUserAllCodesReducer.SMloggedInUserAllCodesReducer,
    SMloggedinUserBusinessDirectCodes: fromSMLoggedInUserDirectBusinessCodesReducer.SMloggedInUserBusinessCodesDataReducer,
    SMloggedinUserOfficeCodes: fromSMLoggedInUserOfficeCodesReducer.SMloggedInUserOfficeCodesDataReducer,
    SMloggedInUserIMDCodes: fromSMLoggedInUserIMDCodesReducer.SMloggedInUserBusinessCodesDataReducer,
    bearerToken: fromTokenActionsReducer.AuthTokenReducer
};
